import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/V2/Isupplier.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('../views/V2/Home.vue'),
      },
      {
        path: '/search-result',
        name: 'LevelOne',
        component: () => import('../views/V2/LevelOne.vue'),
      },
    ],
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/V2/Register.vue'),
  },
  {
    path: '/register-company',
    name: 'RegisterCompany',
    component: () => import('../views/V2/RegisterCompanyName.vue'),
  },
  {
    path: '/error-page',
    name: 'ErrorPage',
    component: () => import('../views/V2/ErrorPage.vue'),
  },
  {
    path: '/reg-google',
    name: 'RegisterGoogle',
    component: () => import('../views/V2/RegisterGoogle.vue'),
  },
  {
    path: '/reset',
    name: 'ResetPassword',
    component: () => import('../views/V2/ResetPassword.vue'),
  },
]

const router = new VueRouter({
  routes,
})

Vue.use(VueAnalytics, {
  id: 'UA-115628282-10',
  router,
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
